"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateItemRequest_1 = require("owa-service/lib/factory/updateItemRequest");
var itemId_1 = require("owa-service/lib/factory/itemId");
var itemChange_1 = require("owa-service/lib/factory/itemChange");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var updateItemOperation_1 = require("owa-service/lib/operation/updateItemOperation");
var createSetItemField_1 = require("owa-mail-store/lib/services/utils/createSetItemField");
function createRequestBody(itemIdsToUpdate, inferenceClassification) {
    var itemChanges = [];
    for (var _i = 0, itemIdsToUpdate_1 = itemIdsToUpdate; _i < itemIdsToUpdate_1.length; _i++) {
        var messageItemId = itemIdsToUpdate_1[_i];
        var update = createSetItemField_1.default('InferenceClassification', inferenceClassification);
        var singleItemChange = itemChange_1.default({
            Updates: [update],
            ItemId: itemId_1.default({
                Id: messageItemId,
            }),
        });
        itemChanges.push(singleItemChange);
    }
    return updateItemRequest_1.default({
        ConflictResolution: 'AlwaysOverwrite',
        ItemChanges: itemChanges,
        OutboundCharset: 'AutoDetect',
    });
}
function setItemsInferenceClassificationService(itemIdsToUpdate, inferenceClassification) {
    var requestBody = createRequestBody(itemIdsToUpdate, inferenceClassification);
    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    var jsonRequestHeader = ServiceRequestUtils_1.getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return updateItemOperation_1.default({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = setItemsInferenceClassificationService;
//# sourceMappingURL=setItemsInferenceClassificationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/setItemsInferenceClassificationService.js
// module id = 5627
// module chunks = 62